module.exports = __webpack_public_path__ + "img/psychology.68c2902f.png";